var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_footer_social_facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_footer_social_facebook"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(6.000000, 6.000000)",
    fill: "#FA7D05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,15.1165831 C16,15.6042711 15.6046961,16 15.1169949,16 L11.0397429,16 L11.0397429,9.80387884 L13.1195554,9.80387884 L13.4311787,7.38940946 L11.0397429,7.38940946 L11.0397429,5.84746132 C11.0397429,5.14839834 11.234126,4.67204184 12.2365504,4.67204184 L13.5152951,4.67160601 L13.5152951,2.51165831 C13.2938901,2.48245805 12.5350985,2.41664851 11.6520934,2.41664851 C9.80850426,2.41664851 8.54632127,3.54194814 8.54632127,5.60862933 L8.54632127,7.38940946 L6.46127864,7.38940946 L6.46127864,9.80387884 L8.54632127,9.80387884 L8.54632127,16 L0.883005094,16 C0.39530386,16 0,15.6042711 0,15.1165831 L0,0.883416866 C0,0.395293092 0.39530386,0 0.883005094,0 L15.1169949,0 C15.6046961,0 16,0.395293092 16,0.883416866 L16,15.1165831",
    id: "Facebook"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.bcfe418e8cb603578a328e0a9d5e18bb.svg";
export { ForwardRef as ReactComponent };